import React from 'react'
import TabsTop from '../Dashboard/components/Tabs'
import MyCourses from '../../components/student/MyCourses/MyCourses'
import MyMessages from '../../components/student/MyMessages/MyMessages'
import MyEvents from '../../components/student/Events/Events'
import AnnouncememntsTab from '../../components/student/Announcements/announcements'
import Tasks from '../../components/student/Tasks/Tasks'


import {Row,Col,Card } from 'antd';


export default function Dashboard() {
    return (
        <div>
                 <Row  gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" span={24}>
                        <Card>
                          <Tasks/>
                        </Card>
                    </Col>
                

                </Row>
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" span={24}>
                      <TabsTop/>
                    </Col>

                </Row>
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                  <br />
                    <Col className="gutter-row" span={24} >
                  <MyCourses/>

                    </Col>
                </Row>
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col span={12}  md={12} xs={24} sm={16}  lg={32} className="gutter-row"> <MyMessages/></Col> 
                    <Col span={12} md={12} xs={24} sm={16} lg={32} className="gutter-row"> <MyEvents/> </Col>
                   
                </Row>
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col span={24}  className="gutter-row"> <AnnouncememntsTab/></Col> 
                
                   
                </Row>
        
        </div>
    )
}
